import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Plus, BookOpen, Pencil, Edit } from 'lucide-react';
import { coursesApi } from '../../lib/api';

export const CourseAuthoring = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    coursesApi.getAll().then(data => {
      setCourses(data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const categoryColors = {
    programming: 'bg-blue-500',
    life_skills: 'bg-green-500',
    safety: 'bg-red-500',
    financial: 'bg-yellow-500',
    career: 'bg-purple-500',
    environment: 'bg-teal-500'
  };

  if (loading) return <div className="skeleton h-64 rounded-lg" />;

  return (
    <div className="space-y-6" data-testid="course-authoring">
      <h1 className="text-2xl font-bold flex items-center gap-2">
        <Pencil className="w-6 h-6" />
        Course Authoring
      </h1>
      <p className="text-muted-foreground">Select a course to edit its chapters, content, and exam questions.</p>
      
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {courses.map(course => (
          <div
            key={course.course_id}
            onClick={() => navigate(`/admin/course-authoring/${course.course_id}`)}
            className="p-4 rounded-lg bg-card border border-border hover:border-primary cursor-pointer transition-all"
            data-testid={`edit-course-${course.course_id}`}
          >
            <div className="flex items-center gap-2 mb-2">
              <Badge className={categoryColors[course.category] || 'bg-gray-500'}>
                {course.category?.toUpperCase() || 'PROGRAMMING'}
              </Badge>
              {course.language && <Badge variant="outline">{course.language}</Badge>}
            </div>
            <h3 className="font-semibold">{course.title}</h3>
            <p className="text-sm text-muted-foreground line-clamp-2 mt-1">{course.description}</p>
            <div className="flex items-center justify-between mt-3 text-sm text-muted-foreground">
              <span>{course.chapters?.length || 7} chapters</span>
              <span className="flex items-center gap-1">
                <Edit className="w-4 h-4" /> Edit
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Course Authoring Detail - Edit Chapters & Questions
